import { IIconProps } from '@fluentui/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import HeaderBarButton from '../../../../../components/ui/HeaderBarButton';
import { routes } from '../../../../../constants/routes';
import { Strategy } from '../../../components/StreamToDatabase/useStreamToDatabase';
import { getHasAnythingSelected, getSendToFileState } from '../../../selectors';
import streamSelectors from '../../../../Streams/selectors';

const EXPORT_ICON_PROPS: IIconProps = {
  iconName: 'Export',
};

const enabledSelectors = {
  [Strategy.ISOLATED]: getHasAnythingSelected,
  [Strategy.OLD_STREAMER]: streamSelectors.getAreAnyColumnsInCurrentDataset,
};

interface Props {
  strategy: Strategy;
  designId: string;
}

const ExportButton: React.FC<Props> = ({ strategy, designId }) => {
  const history = useHistory();
  const isVisibleSelector = useSelector(enabledSelectors[strategy]);
  const { isLoading } = useSelector(getSendToFileState);

  const onClick = React.useCallback(() => {
    history.push(routes.streamer.export.index, {
      strategy,
      designId,
    });
  }, [history]);

  return (
    <HeaderBarButton
      iconProps={EXPORT_ICON_PROPS}
      onClick={onClick}
      shouldHideOnDisabled
      disabled={!isVisibleSelector || isLoading}
      data-testid="export-wizard-btn"
    />
  );
};

export default ExportButton;
